import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["setParentHubspotUtk"];
import { Component } from 'react';
import { connect } from 'react-redux';
import { addHsTrackingCode, removeHsTrackingCode } from '../../utils/analytics';
import { setParentHubspotUtk } from 'MeetingsLib/redux/reducers/parentPageHSAnalyticsInfo';
import { jsx as _jsx } from "react/jsx-runtime";
const mapDispatch = {
  setParentHubspotUtk
};
const connector = connect(null, mapDispatch);
export default function withConsentListeners(WrappedComponent) {
  class WithConsentListeners extends Component {
    constructor(props) {
      super(props);
      this.handleIframeMessaging = event => {
        if (!event || !event.data) return;
        if (event.data.type === 'privacy-consent' && typeof event.data.shouldTrackAnalytics === 'boolean') {
          const {
            shouldTrackAnalytics
          } = event.data;
          this.setState({
            shouldTrackAnalytics
          });
          return;
        }
        if (event.data.type === 'utk-update') {
          const utk = event.data.utk;
          if (typeof utk !== 'string' || utk.length === 0) return;
          // The embed snippet runs in whichever window embeds the iframe,
          // which may be any customer-hosted domain. Accept utk-update only
          // from the direct parent window to block sibling/popup windows
          // and extension-injected scripts, regardless of origin.
          if (event.source !== window.parent) return;
          window.__hsUserToken = utk;
          this.props.setParentHubspotUtk(utk);
        }
      };
      this.state = {
        shouldTrackAnalytics: true
      };
    }
    componentDidMount() {
      const {
        embedded
      } = this.props;
      if (embedded) {
        window.addEventListener('message', this.handleIframeMessaging);
        window.parent.postMessage('readyForConsentListener', '*');
      } else {
        const _hsp = window._hsp = window._hsp || [];
        _hsp.push(['addPrivacyConsentListener', consent => {
          const allowed = consent.allowed;
          const currentCategories = consent.categories;
          const shouldTrackAnalytics = allowed || currentCategories.analytics;
          this.setState({
            shouldTrackAnalytics
          });
        }]);
      }
    }
    componentWillUnmount() {
      const {
        embedded
      } = this.props;
      if (embedded) {
        window.removeEventListener('message', this.handleIframeMessaging);
      }
    }
    componentDidUpdate() {
      const {
        availabilityFetchSuccess,
        embedded,
        portalId,
        useFullTrackingScript
      } = this.props;
      const {
        shouldTrackAnalytics
      } = this.state;
      if (shouldTrackAnalytics !== undefined && availabilityFetchSuccess) {
        if (shouldTrackAnalytics) {
          addHsTrackingCode(portalId, embedded, useFullTrackingScript);
        } else {
          removeHsTrackingCode();
        }
      }
    }
    render() {
      const _this$props = this.props,
        rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
      return /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, rest));
    }
  }
  return connector(WithConsentListeners);
}